import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

function useEvaluation(props) {
  const [userPrimarySkills, setUserPrimarySkills] = useState();

  const { applicantProfileData } = useSelector(
    (state) => state.get_applicant_profile_info_reducer
  );

  useEffect(() => {
    if (applicantProfileData?.data) {
      getUserPrimarySkills(applicantProfileData?.data);
    }
  }, [applicantProfileData]);

  const getUserPrimarySkills = (data) => {
    let skills =
      data?.candidate_profile_details && data.candidate_profile_details?.skills;

    setUserPrimarySkills(skills);
  };

  return {
    userPrimarySkills,
  };
}
export default useEvaluation;
